import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionTemplateListPathParameters } from 'api/actions/revision-template-list/revision-template-list-path-parameters';
import { RevisionTemplateListResponse } from 'api/actions/revision-template-list/revision-template-list-response';

type RevisionTemplateListQueryParameters = Record<string, any>;

/**
 * The path of the RevisionTemplateList action.
 */
export const revisionTemplateListActionPath = new SweetPath<keyof RevisionTemplateListPathParameters>(
  '/api/revision-template/list',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionTemplateList actions.
 */
export default function createRevisionTemplateListAction(axios: AxiosInstance) {
  return function revisionTemplateListAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: RevisionTemplateListQueryParameters } = {}) {
    const path = revisionTemplateListActionPath.original;

    return axios.request<RevisionTemplateListResponse, RevisionTemplateListResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
